import type { Benefit } from '../types/landing';

export const benefits: Benefit[] = [
  {
    icon: 'sprout',
    title: 'Beginner-friendly rec {sport}',
    body: 'Built for first-timers and kids who just love to play. We teach the basics before the scoreboard.',
  },
  {
    icon: 'school',
    title: 'Age-appropriate instruction',
    body: 'Drills, equipment and game formats are matched to each age group, from 3-year-olds to middle schoolers.',
  },
  {
    icon: 'users',
    title: 'All skill levels welcome',
    body: 'Everyone plays every game. Teams are balanced so kids learn alongside friends at their level.',
  },
  {
    icon: 'handshake',
    title: 'Sportsmanship comes first',
    body: 'Each week centers on a value like teamwork or respect, reinforced at practice and on game day.',
  },
  {
    icon: 'mapPin',
    title: 'Close-to-home locations',
    body: 'Play at neighborhood {venueType} around {city}, with practice scheduled right before the game.',
  },
  {
    icon: 'ban',
    title: 'No tryouts. No drafts.',
    body: 'Sign up with friends and request the same team. No fundraising required, either.',
  },
];
